import combineReducers from 'combine-reducers-global-state';

const quizReducers = combineReducers({});

export default { quiz: quizReducers };
